/**
 * 一些业务上的全局缓存
 *
 */

const common = {
  state: {
    // 是否使用局域网的图片缓存
    useLocalAreaNetworkCache: false,
    // zn/ en
    language: 'zn'
  },
  mutations: {
    // 图片链接是否走局域网的服务器
    SET_USE_LOCAL_AREA_NETWORK_CACHE: (state, status) => {
      state.useLocalAreaNetworkCache = status
    },
    SET_LANGUAGE(state, language) {
      state.language = language
    }
  },
  actions: {
    setUseLocalAreaNetworkCache: ({ commit }, status) => {
      commit('SET_USE_LOCAL_AREA_NETWORK_CACHE', status)
    },
    setLanguage({ commit }, language) {
      sessionStorage.setItem('LANGUAGE', language)
      commit('SET_LANGUAGE', language)
    }
  }
}

export default common
